type TableEmptyStateProps = {
  text: string;
};

export const TableEmptyState = ({ text }: TableEmptyStateProps) => (
  <div className='flex h-[321px] items-center justify-center rounded-md bg-elevated-card-2 md:h-[144px]'>
    <p className='text-center text-lg text-brand-1100'>{text}</p>
  </div>
);
